export const ROUTE_TYPE_META = {
  small: { label: "Small", bg: "#DCFCE7", text: "#166534", border: "#BBF7D0", description: "scar14 / scar15" },
  big: { label: "Big", bg: "#FFEDD5", text: "#9A3412", border: "#FED7AA", description: "scar12 / scar13 / scar18" },
  pickup: { label: "Pickup", bg: "#F3E8FF", text: "#6B21A8", border: "#E9D5FF", description: "scar5" },
  walmart: { label: "Walmart", bg: "#E0F2FE", text: "#075985", border: "#BAE6FD", description: "scar9 / walmart" },
  split: { label: "Split", bg: "#FEF3C7", text: "#92400E", border: "#FDE68A", description: "2+ drivers on one route" },
  other: { label: "Other", bg: "#F1F5F9", text: "#334155", border: "#E2E8F0", description: "unclassified" },
};

export function RouteBadge({ type, code }) {
  const meta = ROUTE_TYPE_META[type] || ROUTE_TYPE_META.other;
  return (
    <span
      data-testid={`route-badge-${type}`}
      className="inline-flex items-center gap-1.5 px-2 py-0.5 text-xs font-semibold rounded-sm"
      style={{ backgroundColor: meta.bg, color: meta.text, border: `1px solid ${meta.border}` }}
    >
      {code ? <span className="font-mono-data">{code}</span> : null}
      <span className="uppercase tracking-wider">{meta.label}</span>
    </span>
  );
}
